import appInfo from "../appInfo";
import replaceCss from "../replaceCss";

type fontStyleType = {
  small: number | null,
  medium: number | null,
  big: number | null,
}

const fontSize = {
  small: '12px',
  medium: '14px',
  big: '16px',
};

export const setFontSize = (fontStyle: fontStyleType) => {
  fontSize.small = (fontStyle?.small || 12) + 'px';
  fontSize.medium = (fontStyle?.medium || 14) + 'px';
  fontSize.big = (fontStyle?.big || 16) + 'px';  
}

/**
 * 获取短横线命名的属性
 * @param attribute 属性名
 */
const getKebabCase = (attribute: string) => {
  return attribute.replace(/([A-Z])/g, (value) =>  `-${value.toLocaleLowerCase()}`)
}

const setTheme = (isMobile: boolean, theme?: any) => {
  let replaceThemes: any = {};
  let hd = 1;
  if (isMobile) {
    document.documentElement.style.setProperty('--regular-ff', 'Arial, PingFangSC-Regular, Hiragino Sans GB, Microsoft YaHei, sans-serif');
    document.documentElement.style.setProperty('--diviling-line-color', '#ebebeb');
    !document.documentElement.classList.contains('in_mobile') && document.documentElement.classList.add('in_mobile')
    document.documentElement.style.setProperty('--main-fc', '#333333');
    if (/.*weapp\/(.+)$/.test(navigator.userAgent)) {
      const weappUa = RegExp.$1;
      const weappUaArr = weappUa.split('/');
      if (weappUaArr[2]) {
        document.documentElement.style.setProperty('--primary', weappUaArr[2]);
      }
      /* no.2400676 修复安卓移动端上字体大小放大后尺寸问题 - 不再处理ua中的字体大小 */
      // if (weappUaArr[3]) {
      //   hd = parseFloat(weappUaArr[3]);
      // }
    }
  } else {
    if (!theme) {
      theme = { ...window.TEAMS?.theme };

      const { primaryColor } = theme;
      // 新增数据赋默认值
      if (primaryColor) {
        // hover和focus主题色当前没有默认值时取默认主题色值
        theme.primaryHoverColor || (theme.primaryHoverColor = primaryColor);
        theme.primaryprimaryFocusColor || (theme.primaryFocusColor = primaryColor);
      }
    }

    Object.entries(theme).forEach(([key, value]) => {
      if (!value) {
        return ;
      }
      switch(key) {
        case 'primaryColor': {
          document.documentElement.style.setProperty('--primary', theme.primaryColor);
          document.documentElement.style.setProperty('--primary-focus', theme.primaryColor);
          replaceThemes.primaryColor = theme.primaryColor;
          break;
        }
        case 'primaryHoverColor': {
          document.documentElement.style.setProperty('--primary-hover', theme.primaryHoverColor);
          replaceThemes.primaryHoverColor = theme.primaryHoverColor;
          break;
        }
        case 'primaryFocusColor': {
          document.documentElement.style.setProperty('--primary-focus', theme.primaryFocusColor);
          replaceThemes.primaryFocusColor = theme.primaryFocusColor;
          break;
        }
        case 'bubbleColor': {
          document.documentElement.style.setProperty('--bubble-color', theme.bubbleColor);
          replaceThemes.bubbleColor = theme.bubbleColor;
          break;
        }
        case 'fontColor': {
          if (value === 'light') {
            document.documentElement.style.setProperty('--main-fc', '#666666');
            replaceThemes.fontColor = value;
          } else if (value === 'medium') {
            document.documentElement.style.setProperty('--main-fc', '#111111');
            replaceThemes.fontColor = value;
          } else if (value === 'deep') {
            document.documentElement.style.setProperty('--main-fc', '#000000');
            replaceThemes.fontColor = value;
          } else {
            document.documentElement.style.setProperty('--main-fc', value as string);
            replaceThemes.fontColor = value;
          }
          break;
        }
        case 'fontSize': {
          if (value === 'small') {
            document.documentElement.style.setProperty('--font-size-12', fontSize.small);
            document.documentElement.style.setProperty('--font-size-14', fontSize.medium);
            document.documentElement.style.setProperty('--font-size-16', fontSize.big);
            replaceThemes.fontSize = value;
          }
          if (value === 'medium') {
            document.documentElement.style.setProperty('--font-size-12', fontSize.medium);
            document.documentElement.style.setProperty('--font-size-14', fontSize.big);
            document.documentElement.style.setProperty('--font-size-16', fontSize.big);
            replaceThemes.fontSize = value;
          }
          if (value === 'big') {
            document.documentElement.style.setProperty('--font-size-12', fontSize.big);
            document.documentElement.style.setProperty('--font-size-14', fontSize.big);
            document.documentElement.style.setProperty('--font-size-16', fontSize.big);
            replaceThemes.fontSize = value;
          }
          break;
        }
        default: {
          // 允许自定义样式
          document.documentElement.style.setProperty(`--${getKebabCase(key)}`, value as string);
          break;
        }
      }
    })
  }
  if (!window.TEAMS) {
    window.TEAMS = {};
  }
  if (!window.TEAMS?.theme) {
    window.TEAMS.theme = {};
  }
  window.TEAMS.theme.hd = hd;
  document.documentElement.style.setProperty('--hd', `${hd}px`);
  replaceCss({ themes: replaceThemes });
}

export default setTheme;

//更新favicon
export const updateFavIcon = (_url?: string) => {
  let url = _url || window.TEAMS?.tenantLogo?.faviconUrl || '';
  const { publicDomain, publicUrl } = appInfo('@weapp/layout');
  if (url && url.indexOf('/static/img/') !== -1) {
    url = `${publicDomain}${publicUrl}/build/layout${url}`;
  }
  url && document.querySelector('link[rel="icon"]')?.setAttribute('href', url);
}

// 系统一件置灰
export const initPageGrey = (opened =  window.TEAMS?.greyInfo?.mainPageGreyStatus) => { // 页面置置灰设置
  const filterNames: string[] = ['-webkit-filter', '-moz-filter', '-ms-filter', '-o-filter', 'filter']
  const setFilterStyle = (val: string | null) => {
    try {
      filterNames.forEach((key: string) => {
        if (document.documentElement && document.body.style && typeof document.documentElement.style.setProperty === 'function') {
          document.documentElement.style.setProperty(key, val)
        }
      })
    } catch (err) {
      console.error(err);
    }
  }
  setFilterStyle(opened ? 'grayscale(100%)' : null)
}

export const removeHtmlLang = () => {
  document.documentElement.removeAttribute('lang');
}

export const removeLinkIcon = () => {
  try {
    document.querySelector('link[rel="apple-touch-icon"]')?.remove()
  } catch (error) {
    console.error(error);
  }
}